import { BrowserNames } from "../../../types";
import { useTranslationsContext } from "../../../contexts/TranslationsContext";
import { detectBrowser } from "../../../helpers";

import chrDots from "../../../assets/photos/chr-dots.png";
import frxDots from "../../../assets/photos/frx-dots.png";
import sriShare from "../../../assets/photos/sri-install-app.png";

function StepOne(): JSX.Element {
  const { translation } = useTranslationsContext();
  const browser: BrowserNames = detectBrowser();

  const textMap: Record<string, string> = {
    [BrowserNames.CHROME]: translation.INSTALL_APP_STEP_1_CHROME.defaultMessage,
    [BrowserNames.FIREFOX]: translation.INSTALL_APP_STEP_1_FIREFOX.defaultMessage,
    [BrowserNames.SAFARI]: translation.INSTALL_APP_STEP_1_SAFARI.defaultMessage,
  };

  const imgMap: Record<string, { src: string; className: string }> = {
    [BrowserNames.CHROME]: { src: chrDots, className: "chr-dots" },
    [BrowserNames.FIREFOX]: { src: frxDots, className: "frx-dots" },
    [BrowserNames.SAFARI]: { src: sriShare, className: "sri-share-icon" },
  };

  const text = textMap[browser];
  const img = imgMap[browser];

  if (!text || !img) return <></>;

  return (
    <div className="ath-step-content">
      <span className="ath-step-number">1</span>
      <p className="ath-step-text">{text}</p>
      <div className="ath-img-card">
        <img className={img.className} src={img.src} alt="Step 1" />
      </div>
    </div>
  );
}

export default StepOne;
